/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiErrorCode.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-error-code";

export class AutogenModelEdiErrorCode<RowType extends ModelRow> extends Endpoint<RowType, RowEdiErrorCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiErrorCode extends ModelRow<RowEdiErrorCodeFields> {
	constructor(values?: Partial<RowEdiErrorCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiErrorCodeFields {
	code: string;
	company_id: string;
	description: string;
	id: number;
}

